import { useEffect, useState } from 'react'

interface IOffset {
  top: number
  right: number
  bottom: number
  left: number
}

type Subscriber = () => void

const subscribers = new Set<Subscriber>()

// 目前只实现了 top 逻辑
let curOffset: IOffset = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
}

export function getPageOffset() {
  return curOffset
}

export function setPageOffset({
  top = 0,
  right = 0,
  bottom = 0,
  left = 0,
}: Partial<IOffset>) {
  const newOffset = { top, right, bottom, left }
  if (
    (['top', 'right', 'bottom', 'left'] as (keyof IOffset)[]).every(
      (prop) => newOffset[prop] === curOffset[prop]
    )
  ) {
    // 值不变直接返回
    return
  }
  curOffset = newOffset
  for (const subscriber of subscribers) {
    subscriber()
  }
}

function usePageOffset() {
  const [offset, setOffset] = useState<IOffset>(curOffset)

  useEffect(() => {
    const subscriber = () => {
      setOffset(curOffset)
    }
    subscribers.add(subscriber)
    return () => {
      subscribers.delete(subscriber)
    }
  }, [])

  return offset
}

export default usePageOffset
